import { takeEvery } from 'redux-saga/effects'
import i18next from 'i18next'

import { postPartnersLinks } from '../actions'
// @ts-ignore
import { showInfo } from 'store/entities/toastr/utils'

export default function* postPartnersLinksSuccessSaga() {
  yield takeEvery(postPartnersLinks.success.toString(), handlePostPartnersLinksSuccessSaga)
}

export function handlePostPartnersLinksSuccessSaga({
  payload: {
    errors: { response },
  },
}: any) {
  if (response) {
    try {
      const partnersLinksNames = response.errors && response.errors.join(', ')
      showInfo({
        content: `${i18next.t(response.message)} (${partnersLinksNames})`,
      })
    } catch (e) {
      // @ts-ignore
      throw new Error(e)
    }
  }
}
